/* eslint-disable */
const $ = require('jquery');
const _ = require('lodash');



class Sticky {

    constructor() {
        if (!$('.news-listing__nav').length) return;

        this.element         = $('.news-listing__nav'); // Element gettin' sticky
        this.stickyClass     = 'news-listing__nav--sticky'; // Class when sticky
        this.unstickyClass   = 'news-listing__nav--unsticky'; // Class when not sticky anymore
        this.elementHeight   = this.element.height();
        this.elementArea     = (this.elementHeight + 155);
        this.trigger         = $('.news-list'); // Sticky will be triggered in relation with the scroll position of this element
        this.triggerHeight   = this.trigger.height();
        this.distanceValue   = 155; // At what scroll position the element should get sticky
        this.bottomValue     = 280; // At what scroll position from bottom the element should get back to unsticky

        this.events();

    }

    events() {


        this.menuSticked();

        $(window).on('scroll', _.throttle(()=> {


            this.menuSticked();
            this.scrollTop       = $(window).scrollTop();
            this.elementOffset   = this.element.offset().top;
            this.elementDistance = (this.elementOffset - this.scrollTop);
            this.triggerOffset   = this.trigger.offset().top;
            this.distance        = (this.triggerOffset - this.scrollTop);
            this.bottom          = (this.triggerOffset + this.triggerHeight);
            this.bottomDistance  = (this.bottom - this.scrollTop);



        }, 10));

        $(window).on('resize', _.throttle(()=> {

            this.menuSticked();

        }, 100));



    }

    menuSticked() {


     if ($(window).width() > 720) {

           if (this.distance <= this.distanceValue ) {
                 this.element.addClass(this.stickyClass);

                if (this.bottomDistance <=  this.bottomValue) {
                    this.element.removeClass(this.stickyClass).offset({top: this.elementOffset});
                } else {
                    this.element.addClass(this.stickyClass).css({position: 'fixed'});
                }

            }  else {
                this.element.removeClass(this.stickyClass).css({position: 'static'});
            }
        } else {
            this.element.removeClass(this.stickyClass).css({position: 'static'});
        }
    }
}

export default new Sticky();
